import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateLuckyWheel from '@/modules/promotion/api/hooks/useMutateUpdateLuckyWheel'
import { useQueryClient } from '@tanstack/react-query'
import { LuckyWheelQueryKeys } from '@/modules/promotion/keys'
import { GetLuckyWheelResponse } from '@/modules/promotion/type'

interface IsActiveLuckyWheelProps {
	wheelData: GetLuckyWheelResponse
	onUpdate?: (isActive: boolean) => void
}

export function IsActiveLuckyWheel({
	wheelData,
	onUpdate,
}: IsActiveLuckyWheelProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateLuckyWheel } = useMutationUpdateLuckyWheel()

	const handleMutate = async (value: boolean) => {
		await updateLuckyWheel({
			payload: {
				isActive: value,
			},
		})

		// Call the optional callback to update parent component
		onUpdate?.(value)

		// Invalidate the lucky wheel query to refresh the data
		queryClient.invalidateQueries({
			queryKey: [LuckyWheelQueryKeys.GetLuckyWheel],
		})
	}

	return (
		<div className="flex items-center gap-3">
			<span className="text-sm font-medium">เปิดใช้งาน</span>
			<SetIsActive
				defaultChecked={wheelData.isActive}
				onMutate={handleMutate}
				errorMessage="ไม่สามารถอัพเดทสถานะได้"
			/>
		</div>
	)
}
